import React from 'react'


// Hook
function useGtm()
{
    
    let dataLayer = React.useRef()
    React.useEffect(()=>{
        if( window.dataLayer ){
            dataLayer.current = window.dataLayer
        }
    })

    const push = (event,category, action, label) => {
        if( dataLayer.current ){
            // console.log(window.dataLayer)
            // console.log(event, category, action, label)
            // console.log(dataLayer.current)
            dataLayer.current.push({
                event: event,
                EventCatagory: category,
                EventAction: action, 
                EventLabel: label
            })
        }
    }
    return { push }
}
{/*
dataLayer.push({‘event’: ‘FireEvent’, ‘EventCatagory’:  ‘イベントカテゴリ名’, ‘EventAction’: ‘click’, ‘EventLabel’: ‘イベントラベル名'});
※イベントラベル名はバナーやボタン名、ページと同じにしてください。日本語表記でよいです。
　　例) イベントカテゴリ名「企画名」イベントラベル名「ゲームページ」「価格をチェック_ページ下部」 etc.
 */}

export { useGtm }